/* eslint-disable no-useless-computed-key */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    zIndex: 0,
    width: '100%',
    height: '390px',
    maxWidth: '1170px',
    minHeight: '390px',
    margin: '8% auto',
    '@media (max-width: 922px)': {
      position: 'relative',
      zIndex: 0,
      minHeight: '350px',
    }
  },
  imageContainer: {
    position: 'relative',
    zIndex: -1,
    width: '100%',
    height: '100%',
    minHeight: '390px',
    padding: '0 20px',
    boxSizing: 'border-box',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'top right',
    '@media (max-width: 1024px)': {
      backgroundPosition: 'top center'
    },
    '@media (max-width: 922px)': {
      minHeight: '250px',
      height: '250px'
    }
  },
  contentContainer: {
    background: '#333',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    left: 'auto',
    right: '54%',
    top: 0,
    maxWidth: '380px',
    bottom: 0,
    marginLeft: '54px',
    boxShadow: '10px 10px 20px rgb(0 0 0 / 20%)',
    '@media (max-width: 922px)': {
      right: '30%',
      top: '30%'
    },
    '@media (max-width: 670px)': {
      marginRight: '54px',
      left: 0,
      right: 'auto',
    }
  },
  contentMask: {
    borderWidth: '10px',
    borderStyle: 'solid',
    borderColor: 'rgba(202, 164, 137, 0.3)',
    boxSizing: 'border-box',
    position: 'absolute',
    top: '27px',
    bottom: '27px',
    width: 'calc(100% + 54px)',
    maxWidth: '434px',
    zIndex: -1
  },
  content: {
    color: '#fff',
    fontSize: '24px',
    fontStyle: 'italic',
    lineHeight: '30px',
    maxWidth: '75%',
    paddingBottom: 0,
    marginBottom: 0,
    fontWeight: 400,
    '@media (max-width: 1024px)': {
      fontSize: '20px'
    },
    '@media (max-width: 670px)': {
      fontSize: '16px'
    },
    '@media (max-width: 520px)': {
      fontSize: '12px'
    }
  }
}));

const AboutUsCtaFullSectionPreview = ({
  ctaFullBackgroundImage,
  ctaFullContent
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div
        className={classes.imageContainer}
        style={{backgroundImage: `url(${ctaFullBackgroundImage})`}}
      />
      <div className={classes.contentContainer}>
        <div className={classes.contentMask} />
        <div
          className={classes.content}
          dangerouslySetInnerHTML={{__html: ctaFullContent}}
        />
      </div>
    </div>
  );
};

export default AboutUsCtaFullSectionPreview;
